// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "iconButton__root-1K43o";
var _4 = "optionActionPlusIcon-Srw6b";
var _5 = "optionEdit-1YJsw";
var _6 = "optionAction-1OFEz";
var _7 = "secondary-1gcR-";
var _8 = "action-2tQ_B";
var _9 = "autoHeight-2U9sT";
var _a = "smallBrand-2L8Gy";
var _b = "smallNeitral-2UMWg";
var _c = "smallPrimary-39LuT";
var _d = "smallSecondary-3nb1u";
var _e = "loyaltyButtons__wrapper-Pa5xs";
export { _1 as "__esModule", _2 as "mobile", _3 as "iconButton__root", _4 as "optionActionPlusIcon", _5 as "optionEdit", _6 as "optionAction", _7 as "secondary", _8 as "action", _9 as "autoHeight", _a as "smallBrand", _b as "smallNeitral", _c as "smallPrimary", _d as "smallSecondary", _e as "loyaltyButtons__wrapper" }
export default { "__esModule": _1, "mobile": _2, "iconButton__root": _3, "optionActionPlusIcon": _4, "optionEdit": _5, "optionAction": _6, "secondary": _7, "action": _8, "autoHeight": _9, "smallBrand": _a, "smallNeitral": _b, "smallPrimary": _c, "smallSecondary": _d, "loyaltyButtons__wrapper": _e }
